import ajax from '../../lib/ajax';
import {Store,Module,ActionContext} from 'vuex'
interface dictionaryState{
    trainTypes:any,
    commitmentTypes:any
}
class dictionaryStore implements Module<dictionaryState,any>{
    namespaced=true;
    state = {
        trainTypes: [],
        commitmentTypes: []
    }
    mutations:any = {
        
    }
    actions = {
        // 培训类型
        async GetTrainTypes(content:ActionContext<dictionaryState,any>) {
            if(content.state.trainTypes.length == 0){
                content.state.trainTypes = (await ajax.get('/api/services/app/SysBaseData/GetCatalogItemAsync', {params: {DirectoryCode: 'TT'}})).data.result.items.map((item:any) => {
                    return { label: item.directoryName, value: item.directoryValue}
                })
            }
        },
        // 承诺书类型
        async GetCommitmentTypes(content:ActionContext<dictionaryState,any>) {
            if(content.state.commitmentTypes.length == 0){
                content.state.commitmentTypes = (await ajax.get('/api/services/app/SysBaseData/GetCatalogItemAsync', {params: {DirectoryCode: 'CT'}})).data.result.items.map((item:any) => {
                    return { label: item.directoryName, value: item.directoryValue}
                })
            }
        }
    }
}
const dictionary = new dictionaryStore();
export default dictionary;